<template>
  <div class="down-main" v-if="showImg" @click="showImg = false">
    <img class="point" :src="cdnUrl + 'FpjzO_jMGeN33Qx7p_qHviMS_5bk'" alt="">
    <div class="down-img-main">
        <!-- <img :src="cdnUrl + 'FiWDfd3jfL64bg44oV2R4wMUeLDe'" alt=""> -->
        <p class="col">1. 点击右上角 ··· 按钮</p>
        <p class="col">2. 发送给朋友或发送到朋友圈或在浏览器中打开下载</p>
        <img class="friend" :src="cdnUrl + 'FgYy4gNMiK-oC5YwTwhdk1nabgjb'" alt="">
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            showImg: false
        }
    },
    methods: {
        showTip() {
            this.showImg = true
        }
    }
}
</script>

<style lang="scss" scoped>
.down-main {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    padding: rem(20);
    background: rgba(0,0,0,.6);
    z-index: 100;
}
.down-img-main {
    position: fixed;
    top: 0;
    left: 0;
    margin-top: rem(141);
    padding: 0 rem(20);
    font-size: rem(14);
}
.col {
    color: #fff;
    margin: rem(20) 0;
}
.friend {
    width: 100%;
}
.point {
    float: right;
}
.point:after{
    content:"";//设置内容为空
    height:0;//高度为0
    line-height:0;//行高为0
    display:block;//将文本转为块级元素
    visibility:hidden;//将元素隐藏
    clear:both//清除浮动
}
</style>